export default "__VITE_ASSET__BCzQAdiy__"